import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FileUploadAwareJsonWriter1mx337tg0y9oj as FileUploadAwareJsonWriter } from '../json/internal/FileUploadAwareJsonWriter.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../json/BufferedSinkJsonWriter.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { urlEncoded5v8jd8by0u4 as urlEncode } from './internal/UrlEncode.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../CustomScalarAdapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from '../json/MapJsonWriter.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  HttpHeader1d7ldebjomr00 as HttpHeader,
  HttpMethod_Post_getInstance1acsve6b42vet as HttpMethod_Post_getInstance,
  HttpMethod_Get_getInstance139ackgavp29i as HttpMethod_Get_getInstance,
  Builder2ocxamygt14i4 as Builder,
} from './Http.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../Subscription.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../json/JsonWriters.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../okio-parent-okio/okio/Okio.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildGetUrl($this, serverUrl, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions) {
  return $this.r48(serverUrl, composeGetParams($this, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions));
}
function composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter) {
  var uploads = {_v: null};
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  writer.q41();
  writer.s48('operationName');
  writer.c42(operation.operationName());
  writer.s48('variables');
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())(writer);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.q41();
  operation.q47(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.r41();
  uploads._v = uploadAwareWriter.v48();
  if (!(query == null)) {
    writer.s48('query');
    writer.c42(query);
  }
  extensionsWriter(writer);
  writer.r41();
  return uploads._v;
}
function composePostParams_0($this, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query) {
  return composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter($this, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
}
function extensionsWriter($this, apqId, sendApqExtensions, sendEnhancedClientAwarenessExtensions) {
  if (!sendApqExtensions && !sendEnhancedClientAwarenessExtensions) {
    return DefaultHttpRequestComposer$Companion$extensionsWriter$lambda;
  }
  return (_this__u8e3s4) => {
    _this__u8e3s4.s48('extensions');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    _this__u8e3s4.q41();
    if (sendApqExtensions) {
      _this__u8e3s4.s48('persistedQuery');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.q41();
      _this__u8e3s4.s48('version').e42(1);
      _this__u8e3s4.s48('sha256Hash').c42(apqId);
      _this__u8e3s4.r41();
    }
    if (sendEnhancedClientAwarenessExtensions) {
      _this__u8e3s4.s48('clientLibrary');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.q41();
      _this__u8e3s4.s48('name').c42('apollo-kotlin');
      _this__u8e3s4.s48('version').c42('4.4.3');
      _this__u8e3s4.r41();
    }
    _this__u8e3s4.r41();
    return Unit_instance;
  };
}
function composeGetParams($this, operation, customScalarAdapters, autoPersistQueries, sendDocument, sendEnhancedClientAwareness) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var queryParams = LinkedHashMap().bc();
  queryParams.x4('operationName', operation.operationName());
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer = new (Buffer())();
  var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())($this$buildJsonString);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.q41();
  operation.q47(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.r41();
  // Inline function 'kotlin.check' call
  if (!uploadAwareWriter.v48().n1()) {
    var message = 'FileUpload and Http GET are not supported at the same time';
    throw IllegalStateException().o(toString(message));
  }
  var variables = buffer.e3z();
  queryParams.x4('variables', variables);
  if (sendDocument) {
    queryParams.x4('query', operation.w48());
  }
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer_0 = new (Buffer())();
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  var this_0 = new (BufferedSinkJsonWriter())(buffer_0, null);
  this_0.q41();
  if (autoPersistQueries) {
    this_0.s48('persistedQuery');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.q41();
    this_0.s48('version').e42(1);
    this_0.s48('sha256Hash').c42(operation.operationId());
    this_0.r41();
  }
  if (sendEnhancedClientAwareness) {
    this_0.s48('clientLibrary');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.q41();
    this_0.s48('name').c42('apollo-kotlin');
    this_0.s48('version').c42('4.4.3');
    this_0.r41();
  }
  this_0.r41();
  var extensions = buffer_0.e3z();
  // Inline function 'kotlin.text.isEmpty' call
  if (!(charSequenceLength(extensions) === 0)) {
    queryParams.x4('extensions', extensions);
  }
  return queryParams;
}
function DefaultHttpRequestComposer$Companion$extensionsWriter$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
function DefaultHttpRequestComposer$Companion$buildPostBody$1() {
  if (DefaultHttpRequestComposer$Companion$buildPostBody$1Class === VOID) {
    class $ {
      constructor($operationByteString) {
        this.z48_1 = $operationByteString;
        this.x48_1 = 'application/json';
        this.y48_1 = fromInt($operationByteString.q2());
      }
      h48() {
        return this.x48_1;
      }
      i48() {
        return this.y48_1;
      }
      k48(bufferedSink) {
        bufferedSink.m3z(this.z48_1);
      }
    }
    initMetadataForClass($);
    DefaultHttpRequestComposer$Companion$buildPostBody$1Class = $;
  }
  return DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.l48_1 = 'X-APOLLO-OPERATION-ID';
        this.m48_1 = 'X-APOLLO-OPERATION-NAME';
        this.n48_1 = 'Apollo-Require-Preflight';
        this.o48_1 = 'Accept';
        this.p48_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
        this.q48_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
      }
      r48(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1(_this__u8e3s4);
        var hasQuestionMark = contains(_this__u8e3s4, '?');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = parameters.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (hasQuestionMark) {
            this_0.o1(_Char___init__impl__6a9atx(38));
          } else {
            hasQuestionMark = true;
            this_0.o1(_Char___init__impl__6a9atx(63));
          }
          this_0.m1(urlEncode(element.m3()));
          this_0.o1(_Char___init__impl__6a9atx(61));
          this_0.m1(urlEncode(element.n3()));
        }
        return this_0.toString();
      }
      a49(operation, customScalarAdapters, query, extensionsWriter) {
        var uploads = {_v: null};
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        uploads._v = composePostParams(Companion_instance, $this$buildJsonByteString, operation, customScalarAdapters, query, extensionsWriter);
        var operationByteString = buffer.a3z();
        var tmp;
        if (uploads._v.n1()) {
          tmp = new (DefaultHttpRequestComposer$Companion$buildPostBody$1())(operationByteString);
        } else {
          tmp = new (UploadsHttpBody())(uploads._v, operationByteString);
        }
        return tmp;
      }
      b49(apolloRequest) {
        var operation = apolloRequest.t43_1;
        var tmp0_elvis_lhs = apolloRequest.y43_1;
        var sendApqExtensions = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.f44_1;
        var tmp1_elvis_lhs = apolloRequest.z43_1;
        var sendDocument = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.v43_1.c47(Key_getInstance());
        var customScalarAdapters = tmp2_elvis_lhs == null ? Key_getInstance().l46_1 : tmp2_elvis_lhs;
        var query = sendDocument ? operation.w48() : null;
        // Inline function 'com.apollographql.apollo.api.json.buildJsonMap' call
        var writer = new (MapJsonWriter())();
        composePostParams_0(Companion_instance, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query);
        var tmp = writer.t41();
        return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DefaultHttpRequestComposerClass;
function DefaultHttpRequestComposer() {
  if (DefaultHttpRequestComposerClass === VOID) {
    class $ {
      constructor(serverUrl) {
        this.c49_1 = serverUrl;
      }
      d49(apolloRequest) {
        var operation = apolloRequest.t43_1;
        var tmp0_elvis_lhs = apolloRequest.v43_1.c47(Key_getInstance());
        var customScalarAdapters = tmp0_elvis_lhs == null ? Key_getInstance().l46_1 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().p2();
        var tmp = apolloRequest.t43_1;
        if (isInterface(tmp, Subscription())) {
          this_0.i2(new (HttpHeader())(Companion_instance.o48_1, Companion_instance.q48_1));
        } else {
          this_0.i2(new (HttpHeader())(Companion_instance.o48_1, Companion_instance.p48_1));
        }
        if (!(apolloRequest.x43_1 == null)) {
          this_0.u2(apolloRequest.x43_1);
        }
        var requestHeaders = this_0;
        var tmp1_elvis_lhs = apolloRequest.y43_1;
        var sendApqExtensions = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.z43_1;
        var sendDocument = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.f44_1;
        var tmp3_elvis_lhs = apolloRequest.w43_1;
        var tmp_0;
        switch ((tmp3_elvis_lhs == null ? HttpMethod_Post_getInstance() : tmp3_elvis_lhs).w1_1) {
          case 0:
            tmp_0 = (new (Builder())(HttpMethod_Get_getInstance(), buildGetUrl(Companion_instance, this.c49_1, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions))).j49(Companion_instance.n48_1, 'true');
            break;
          case 1:
            var query = sendDocument ? operation.w48() : null;
            var body = Companion_instance.a49(operation, customScalarAdapters, query, extensionsWriter(Companion_instance, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
            // Inline function 'kotlin.let' call

            var it = (new (Builder())(HttpMethod_Post_getInstance(), this.c49_1)).k49(body);
            var tmp_1;
            if (startsWith(body.h48(), 'multipart/form-data')) {
              tmp_1 = it.j49(Companion_instance.n48_1, 'true');
            } else {
              tmp_1 = it;
            }

            tmp_0 = tmp_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var httpRequestBuilder = tmp_0;
        return httpRequestBuilder.l49(requestHeaders).s44(apolloRequest.v43_1).c38();
      }
    }
    initMetadataForClass($, 'DefaultHttpRequestComposer');
    DefaultHttpRequestComposerClass = $;
  }
  return DefaultHttpRequestComposerClass;
}
function buildUploadMap($this, uploads) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = uploads.l3();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$4 = to(index_0.toString(), listOf(item.m3()));
    destination.i2(tmp$ret$4);
  }
  writeAny($this$buildJsonByteString, toMap(destination));
  return buffer.a3z();
}
function writeBoundaries($this, $receiver, writeUploadContents) {
  $receiver.o3z('--' + $this.o49_1 + '\r\n');
  $receiver.o3z('Content-Disposition: form-data; name="operations"\r\n');
  $receiver.o3z('Content-Type: application/json\r\n');
  $receiver.o3z('Content-Length: ' + $this.n49_1.q2() + '\r\n');
  $receiver.o3z('\r\n');
  $receiver.m3z($this.n49_1);
  var uploadsMap = buildUploadMap($this, $this.m49_1);
  $receiver.o3z('\r\n--' + $this.o49_1 + '\r\n');
  $receiver.o3z('Content-Disposition: form-data; name="map"\r\n');
  $receiver.o3z('Content-Type: application/json\r\n');
  $receiver.o3z('Content-Length: ' + uploadsMap.q2() + '\r\n');
  $receiver.o3z('\r\n');
  $receiver.m3z(uploadsMap);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = $this.m49_1.w4().p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    $receiver.o3z('\r\n--' + $this.o49_1 + '\r\n');
    $receiver.o3z('Content-Disposition: form-data; name="' + index_0 + '"');
    if (!(item.j48() == null)) {
      $receiver.o3z('; filename="' + item.j48() + '"');
    }
    $receiver.o3z('\r\n');
    $receiver.o3z('Content-Type: ' + item.h48() + '\r\n');
    var contentLength = item.i48();
    if (!(contentLength === -1n)) {
      $receiver.o3z('Content-Length: ' + contentLength.toString() + '\r\n');
    }
    $receiver.o3z('\r\n');
    if (writeUploadContents) {
      item.k48($receiver);
    }
  }
  $receiver.o3z('\r\n--' + $this.o49_1 + '--\r\n');
}
function UploadsHttpBody$_get_contentLength_$ref_e5o4rd() {
  return (p0) => p0.i48();
}
var UploadsHttpBodyClass;
function UploadsHttpBody() {
  if (UploadsHttpBodyClass === VOID) {
    class $ {
      constructor(uploads, operationByteString) {
        this.m49_1 = uploads;
        this.n49_1 = operationByteString;
        this.o49_1 = uuid4().toString();
        this.p49_1 = 'multipart/form-data; boundary=' + this.o49_1;
        var tmp = this;
        tmp.q49_1 = lazy(() => {
          var countingSink = new (CountingSink())(blackholeSink());
          var bufferedCountingSink = buffer(countingSink);
          writeBoundaries(this, bufferedCountingSink, false);
          bufferedCountingSink.lc();
          var tmp = countingSink.s49_1;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0n;
          var _iterator__ex2g4s = this.m49_1.w4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_0 = sum;
            var tmp$ret$1 = element.i48();
            sum = add(tmp_0, tmp$ret$1);
          }
          var tmp$ret$0 = sum;
          var result = add(tmp, tmp$ret$0);
          return result;
        });
      }
      h48() {
        return this.p49_1;
      }
      i48() {
        var tmp0 = this.q49_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('contentLength', 1, tmp, UploadsHttpBody$_get_contentLength_$ref_e5o4rd(), null);
        return tmp0.n3();
      }
      k48(bufferedSink) {
        writeBoundaries(this, bufferedSink, true);
      }
    }
    initMetadataForClass($, 'UploadsHttpBody');
    UploadsHttpBodyClass = $;
  }
  return UploadsHttpBodyClass;
}
var CountingSinkClass;
function CountingSink() {
  if (CountingSinkClass === VOID) {
    class $ {
      constructor(delegate) {
        this.r49_1 = delegate;
        this.s49_1 = 0n;
      }
      w3v(source, byteCount) {
        this.r49_1.w3v(source, byteCount);
        this.s49_1 = add(this.s49_1, byteCount);
      }
      l6() {
        this.r49_1.l6();
      }
      lc() {
        this.r49_1.lc();
      }
    }
    initMetadataForClass($, 'CountingSink');
    CountingSinkClass = $;
  }
  return CountingSinkClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DefaultHttpRequestComposer as DefaultHttpRequestComposer3cbqxfvy17yg2,
  Companion_instance as Companion_instancegdssxde1x86b,
};
//endregion

//# sourceMappingURL=DefaultHttpRequestComposer.mjs.map
